import { restClient } from '@/Core'

import { toCollection, toNode } from '../Helpers/diskResponse'

import type { DiskCollection, DiskNode, DiskSort } from '../Contracts/DiskNode'

/**
 * Пошук за назвою по всьому доступному, без кошика й без чужих особистих
 * дисків: `GET /services/disk/search?q=`.
 */
export const SearchDiskNodesTask = async (query: string, sort: DiskSort): Promise<DiskCollection<DiskNode>> => {
    const response = (await restClient.get(
        '/services/disk/search',
        { searchParams: { q: query, sort: sort.field, order: sort.order, limit: '100' } },
        { forceRefresh: true }
    )) as unknown

    return toCollection(response, toNode)
}
